import {
    Page,
    Stack,
    Banner,
    ResourceItem,
    ResourceList,
    EmptyState,
    Card,
    TextStyle,
    Filters,
    SkeletonBodyText,
    Layout,
    Tooltip,
    Icon
} from '@shopify/polaris';
import {
    ReceiptMajor, RiskMajor
} from '@shopify/polaris-icons';
import { apiFetch as fetch } from '../../common/Helpers';
import StatItem from '../../components/filtering/StatItem';
import moment from 'moment';
import React, { Component } from 'react'
import { Helmet } from 'react-helmet';
import { GenieTag } from '../../components/GenieTag';

class TagGroupsIndexPage extends Component {

    constructor(props) {
        super(props)

        this.state = {
            isLoading: true,
            evaluation: {
                exists: false,
                failingGroups: "?",
                failingGroupIds: [],
                failingResources: "?",
                inProgress: false
            },
            tagGroups: [],
            sortValue: 'DATE_CREATED_DESC',
            queryValue: null,
        };
    }

    render() {

        if (this.state.isLoading)
            return <SkeletonBodyText lines="20" />;

        const emptyStateMarkup =
            <EmptyState
                heading="Create a tag groups to categorize all of your tags"
                action={{
                    content: 'Create Tag Group', onAction: () => { this.handleCreate(); }
                }
                }
                image="https://cdn.shopify.com/s/files/1/2376/3301/products/emptystate-files.png"
            >
                <p>
                    You can use tag groups to categorize all of your tags and allow Tag Genie to detect misspelled tags and resources that have missing or incorrect tags.
                </p>
            </EmptyState >

        const totalGroups = this.state.tagGroups.length;
        const groupsWithValidations = this.state.tagGroups.filter(_ => _.hasRule).length;
        let tagGroups = this.state.tagGroups
            .filter(item => this.state.queryValue == null || item.name.toUpperCase().includes(this.state.queryValue.toUpperCase()))
            .map((item, index) => {
                return {
                    id: item.id,
                    url: `/tag-groups/${item.id}`,
                    name: item.name,
                    tags: item.tags,
                    color: item.color,
                    hasRule: item.hasRule,
                    hasFailures: this.state.evaluation.failingGroupIds.includes(item.id),
                    created: new Date(item.dateCreated),
                }
            }).sort((a, b) => {
                switch (this.state.sortValue) {
                    case 'NAME_ASC':
                        return a.name.localeCompare(b.name);
                    case 'NAME_DESC':
                        return b.name.localeCompare(a.name);
                    case 'DATE_CREATED_ASC':
                        return a.created - b.created;
                    case 'DATE_CREATED_DESC':
                    default:
                        return b.created - a.created;
                }
            });

        const evaluationInProgress = this.state.evaluation != null && this.state.evaluation.inProgress;
        const notRecent = this.state.evaluation != null && this.state.evaluation.notRecent;

        return (
            <div>
                <Helmet>
                    <title>Tag Genie - Tag Groups</title>
                </Helmet>
                <Page
                    title="Tag Groups"
                    primaryAction={{ content: 'Create Tag Group', onAction: () => { this.handleCreate(); } }}
                    secondaryActions={[{ content: 'Schedule Rule Evaluation', onAction: () => { this.requestEvaluation(); }, disabled: evaluationInProgress }]}
                >
                    <Layout>
                        {evaluationInProgress && <Layout.Section>
                            <Banner
                                title="Evaluation in progress"
                                status="info"
                                onDismiss={null}
                            >
                                <p>Tag group rules are being evaluated. Please check back in a couple of minutes.</p>
                            </Banner>
                        </Layout.Section>}
                        {notRecent && <Layout.Section>
                            <Banner
                                title="Not Recent"
                                status="warning"
                                onDismiss={null}
                            >
                                <p>Evaluation of the tag groups hasn't been scheduled recently. Please, schedule a new one to get updates view.</p>
                            </Banner>
                        </Layout.Section>}
                        <Layout.Section title="sfsfds">
                            <Stack vertical={false} distribution="leading" spacing="extraLoose"  >
                                <Card sectioned>
                                    <StatItem
                                        title="Total Groups"
                                        stat={totalGroups}
                                        text="Total number of tag groups."
                                    />
                                </Card>
                                <Card sectioned>
                                    <StatItem
                                        title="Groups With Validations"
                                        stat={<TextStyle variation="negative">{groupsWithValidations}</TextStyle>}
                                        text="Total groups with validation rules defined."
                                    />
                                </Card>
                                <Card sectioned>
                                    <StatItem
                                        title="Groups With Errors"
                                        stat={<TextStyle variation="negative">{this.state.evaluation.failingGroups}</TextStyle>}
                                        text="Number of groups with validation errors."
                                    />
                                </Card>
                                <Card sectioned>
                                    <StatItem
                                        title="Total Failing Resources"
                                        stat={<TextStyle variation="negative">{this.state.evaluation.failingResources}</TextStyle>}
                                        text="Number of reosurces that do not meet the group rules."
                                    />
                                </Card>
                            </Stack>
                        </Layout.Section>
                        <Layout.Section>
                            <Card >
                                <Card.Section>
                                    <Filters
                                        queryValue={this.state.queryValue}
                                        queryPlaceholder="Filter tag groups by name"
                                        filters={[]}
                                        appliedFilters={[]}
                                        onQueryChange={(value) => this.setState({ queryValue: value })}
                                        onQueryClear={() => this.setState({ queryValue: null })}
                                        onClearAll={() => this.setState({ queryValue: null })}
                                    />
                                    <ResourceList
                                        emptyState={emptyStateMarkup}
                                        resourceName={{ singular: 'tag group', plural: 'tag groups' }}
                                        items={tagGroups}
                                        renderItem={this.renderItem}
                                        sortValue={this.state.sortValue}
                                        sortOptions={[
                                            { label: 'Name A-Z', value: 'NAME_ASC' },
                                            { label: 'Name Z-A', value: 'NAME_DESC' },
                                            { label: 'Newest', value: 'DATE_CREATED_DESC' },
                                            { label: 'Oldest', value: 'DATE_CREATED_ASC' },
                                        ]}
                                        onSortChange={(selected) => this.setState({ sortValue: selected })}
                                    />
                                </Card.Section>
                            </Card>
                        </Layout.Section>
                    </Layout>
                </Page>
            </div >
        );
    }

    renderItem = (item) => {
        const { id, name, tags, color, url, hasRule, hasFailures } = item;

        return (
            <ResourceItem id={id} url={url}>
                <div>
                    <Stack>
                        <Stack.Item fill>
                            <TextStyle variation="strong">Tag Group: {name}</TextStyle>
                        </Stack.Item>
                        {hasRule && <Stack.Item>
                            <Tooltip content="Group has rule defined">
                                <Icon source={ReceiptMajor} color="base" />
                            </Tooltip>
                        </Stack.Item>}
                        {hasFailures && <Stack.Item>
                            <Tooltip content="Group has failing items">
                                <Icon source={RiskMajor} color="critical" />
                            </Tooltip>
                        </Stack.Item>
                        }
                    </Stack>
                    <br />
                    <br />
                    <Stack>
                        {tags.map(item => <GenieTag backgroundColor={color}>{item}</GenieTag>)}
                    </Stack>
                </div>
            </ResourceItem>
        );

    }

    parseDate(stringDate) {
        var momentDate = moment(stringDate);
        return momentDate.toDate();
    }

    handleCreate() {
        this.props.history.push("/tag-groups/new");
    }

    requestEvaluation = () => {
        fetch(`api/tagGroups/scheduleValidation`, {
            method: 'POST',
        }).then(response => response.json())
            .then(data => this.setState({
                evaluation: data,
            }));
    }

    fetchEvaluation = () => {
        fetch(`api/tagGroups/evaluation`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => this.setState({
                evaluation: data,
            }));
    }

    componentDidMount() {
        this.fetchEvaluation();
        fetch(`api/tagGroups/`, {
            method: 'GET'
        })
            .then(response => response.json())
            .then(data => this.setState({
                tagGroups: data,
                isLoading: false
            }));
    }
}

export default TagGroupsIndexPage